var parent = require('../../es/object/define-property');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/features/object/define-property.js
// module id = 1018
// module chunks = 0